import React, { useMemo } from 'react';
import { VaultUnstakingTable } from './VaultUnstakingTable';
import { useStakingContext } from '../contexts/staking.context';

export const History = () => {
  const { unstakeList } = useStakingContext();
  const unstakeColumns = [
    {
      id: 1,
      columnName: 'Unstaked',
    },
    {
      id: 2,
      columnName: 'Initiated',
    },
    {
      id: 3,
      columnName: 'Withdrawal date',
    },
  ];

  const filtredUnstakeList = useMemo(
    () => unstakeList.filter((transaction) => transaction?.processed),
    [unstakeList],
  );

  return (
    <VaultUnstakingTable
      unstakeList={filtredUnstakeList}
      unstakeColumns={unstakeColumns}
    />
  );
};
